import { TicketSalePageEvent } from 'app/pages/TicketSalePage/slice/types';

export const getBundledAddonsForTicketCategory = (
  event: TicketSalePageEvent,
  ticketId: string,
) => {
  const ticketType = event.tickets.find(({ id }) => id === ticketId);

  if (!ticketType) return [];

  return ticketType.ticketaddons.filter(({ is_bundled }) => is_bundled === 1);
};
